var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"loader-block",style:({ minHeight: _vm.minHeight })},[_c('loader',{attrs:{"loading":true,"title":_vm.title}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }